export default __webpack_public_path__ + "static/product-background-540dd28489870be155d3d5519aa8f885.png";